// module
import React from 'react';
import { Link } from 'react-router-dom';

// my components
import DownloadLinks from '../components/DownloadLinks';
import OptionTable from '../components/OptionTable';
import CommandBox from '../components/CommandBox';
import ShowImg from '../components/ShowImg';

// img
import singleDownloadImg from '../img/download_img.png';
import figureImg from '../img/Figure_S1.png';

function Gaap03Gap(){
    window.scrollTo(0,0);
    return(
        <div className="content">
            <h2 className="content_title"><em>De novo</em> assembly </h2>
            <h2 className="content_title2">Gap filling</h2>
            <div className="content_text">
                In the assembly stage, the sequencing reads are 
                assembled to obtain scaffolds, after which gap filling 
                is performed to improve the accuracy of the scaffolds. 
                In GAAP, GapCloser is used for filling gaps.
            </div><br/>
            <div className="content_command_title">GapCloser</div><br/>
            <div className="content_text">
                GapCloser performs gap-filling by realigning 
                reads to the assembled scaffolds while considering 
                relationships between paired-end reads.
            </div><br/>
            <li className="content_description">Download</li>
            <div className="content_download_box">
                <div className="content_download_img">
                    <img src={singleDownloadImg} alt="error"/>
                </div>
                <div className="content_download_links">
                    <br/><br/>
                    <DownloadLinks link="https://sourceforge.net/projects/soapdenovo2/files/GapCloser" />
                    <br/>
                </div>
            </div><br/>
            <li className="content_description">GapCloser Command</li>
            <CommandBox lines={[
                {data:
                    `GapCloser -a scaffold.scafSeq -b config.file -o genome.fasta -l readlength`
                },
            ]}
            /><br/>
            <li className="content_description">Options for GapCloser</li>
            <OptionTable
                data={[
                    {   option:'-a',
                        desc:'specify the assembled scaffold file'},
                    {   option:'-b',
                        desc:'specify the configuration file'},
                    {   option:`-o`,
                        desc:'specify the output file'},
                    {   option:'-l',
                        desc:'specify the maximum read length'},    
                ]}
            /><br />
            <li className="content_description">Output of GapCloser</li>
            <div className="content_text">
                genome.fasta: stores the new gap-filled scaffold sequences&nbsp;
                <ShowImg name="(Supplementary Figure S1)"
                        src= {figureImg}
                />.
            </div><br/>
            <div className="content_buttons_div">
                <Link to="/Gaap03_Velvet"><button className="content_button">Pre&ensp;</button></Link>
                <Link to="/Gaap04"><button className="content_button">Next</button></Link>
            </div>
        </div>
    );
}

export default Gaap03Gap;